export enum NotificationStatus {
  AllNotifications,
  UnreadNotifications,
}

export enum NotificationType {
  ClubInvitation,
  ApplicationForClub,
  FundraiseInProgress,
  StakingOpened,
  StakingOver,
  DiscussionProposalCreated,
  TradingProposalCreated,
  WithdrawalProposalCreated,
  TradeExecutedBuy,
  TradeExecutedSell,
  TradingProposalSucceeded,
  DiscussionProposalSucceeded,
  WithdrawalProposalSucceeded,
  TradingProposalDefeated,
  DiscussionProposalDefeated,
  WithdrawalProposalDefeated,
  TransferProposalCreated = 20,
  TransferProposalSucceeded = 21,
  TransferProposalDefeated = 22,
}

export const NotificationTypeLabel = {
  [NotificationType.DiscussionProposalCreated]: "Discussion",
  [NotificationType.DiscussionProposalSucceeded]: "Discussion",
  [NotificationType.DiscussionProposalDefeated]: "Discussion",
  [NotificationType.TradingProposalCreated]: "Trading",
  [NotificationType.TradeExecutedBuy]: "Trading",
  [NotificationType.TradeExecutedSell]: "Trading",
  [NotificationType.TradingProposalSucceeded]: "Trading",
  [NotificationType.TradingProposalDefeated]: "Trading",
  [NotificationType.WithdrawalProposalCreated]: "Withdrawal",
  [NotificationType.WithdrawalProposalSucceeded]: "Withdrawal",
  [NotificationType.WithdrawalProposalDefeated]: "Withdrawal",
  [NotificationType.TransferProposalCreated]: "Transfer",
  [NotificationType.TransferProposalSucceeded]: "Transfer",
  [NotificationType.TransferProposalDefeated]: "Transfer",
};
